export default class SignatureCopy {
    constructor () {
        this.signatureBtn = document.querySelectorAll('[data-email-signature="btn"]')

        // If there's no signature copy buttons, return
        if (!this.signatureBtn)
            return

        this.signatureBtn.forEach(btn => this.watch(btn))
    }

    watch (el) {
        const card = el.closest('[data-email-signature="card"]')

        if (!card)
            return

        el.addEventListener('click', () => this.copy(card))
    }

    copy (card) {
        const markup = card.querySelector('[data-email-signature="markup"]')

        if (!markup)
            return

        if (typeof ClipboardItem === 'undefined') {
            console.error('[Brand Signature Copy]\n'
                + 'This feature is not available in the browser you are using.\n'
                + 'Please select the text and copy to your email.')
            return
        }

        const type = 'text/html'
        const blob = new Blob([markup.innerHTML], { type }) // eslint-disable-line no-undef
        const data = [new ClipboardItem({ [type]: blob })] // eslint-disable-line no-undef

        const error = () => {
            console.error('[Brand Signature Copy] There was an error, try again.')
        }

        const success = () => {
            const css = 'brand-card-email-copied'
            card.classList.add(css)

            setTimeout(() => {
                card.classList.remove(css)
            }, 2000)
        }

        navigator.clipboard
            .write(data)
            .then(success, error)
    }
}
